import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminHomePage from '../adminpanel/pages/AdminHomePage';
import AdminUsersPage from '../adminpanel/pages/AdminUsersPage';
import AdminLeadsPage from '../adminpanel/pages/AdminLeadsPage';
import AdminBoatsPage from '../adminpanel/pages/AdminBoatsPage';
import AdminCategoriesPage from '../adminpanel/pages/AdminCategoriesPage';
import AdminReviewsPage from '../adminpanel/pages/AdminReviewsPage';
import AdminLoginPage from '../users/pages/admin/AdminLoginPage';
import AdminSignUpPage from '../users/pages/admin/AdminSignUpPage';
import AdminForgotPassword from '../users/pages/admin/AdminForgotPasswordPage';
import AdminResetPasswordConfirmPage from '../users/pages/admin/AdminResetPasswordConfirmPage';
// import AdminPackReservationsPage from '../adminpanel/pages/AdminPackReservationsPage';
// import AdminSettingsPage from '../adminpanel/pages/AdminSettingsPage';

// Blog pages
import AdminBlogPostsPage from '../adminpanel/pages/AdminBlogPostsPage';
import AdminBlogCategoriesPage from '../adminpanel/pages/AdminBlogCategoriesPage';

// Sales Popup page
import AdminSalesPopupPage from '../adminpanel/pages/AdminSalesPopupPage';

import ProtectedRouteAdmin from './ProtectedRouteAdmin';

const AdminRouter = () => (
  <Routes>
    <Route path="login" element={<AdminLoginPage />} />
    <Route path="sign-up" element={<AdminSignUpPage />} />
    <Route path="forgot-password" element={<AdminForgotPassword />} />
    <Route path="api/users/reset/:uidb64/:token" element={<AdminResetPasswordConfirmPage />} />

    <Route element={<ProtectedRouteAdmin />}>
      <Route path="/" element={<AdminHomePage />} />
      <Route path="users" element={<AdminUsersPage />} />
      <Route path="boats" element={<AdminBoatsPage />} />
      {/* <Route path="settings" element={<AdminSettingsPage />} /> */}
      <Route path="leads" element={<AdminLeadsPage />} />
      <Route path="categories" element={<AdminCategoriesPage />} />
      <Route path="reviews" element={<AdminReviewsPage />} />
      
      {/* Blog routes */}
      <Route path="blog/posts" element={<AdminBlogPostsPage />} />
      <Route path="blog/categories" element={<AdminBlogCategoriesPage />} />
      
      {/* Sales Popup route */}
      <Route path="sales-popup" element={<AdminSalesPopupPage />} />
    </Route>

  </Routes>
);

export default AdminRouter;